import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'lib-flexible';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import WaterMarkContent from './Components/WaterMarkContent';
import DisableDevtool from 'disable-devtool';


ReactDOM.render(<WaterMarkContent text={'山香教育'} fillOpacity={'0.4'}  fillColor ={'#333'} fontSize = {18}>
    <App />
</WaterMarkContent>, document.getElementById('root'));

 
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// DisableDevtool();